import { Community, Contact, ChangeType, Lot, MasterTask, RecordableAttachment, RecordableCategory, RecordablePriorityName, RecordableStatusName, RecordableTypeName, ScheduleTask, StagedBlob, Vendor } from "./index";

export class Recordable {
    public id: number;
    public idDateDisplayName: string;
    public marketId: number;
    public financialCommunityId: number;
    public community: Community;
    public communityDisplayName: string;
    public lotId?: number;
    public lot: Lot;
    public scheduleTaskId: number;
    public scheduleTask: ScheduleTask;
    public masterTask: MasterTask;
    public masterTaskDisplayName: string;
    public recordableTypeName: RecordableTypeName;
    public description: string;
    public recordableCategoryId: number;
    public recordableCategory: RecordableCategory;
    public recordableCategoryDisplayName: string;
    public recordableDate: Date;
    public recordableDateString: string;
    public recordablePriorityName: RecordablePriorityName;
    public recordableStatusName: RecordableStatusName;
    public recordablePriorityStatusDisplayName: string;
    public closedUtcDate?: Date;
    public ownerId: number;
    public owner: Contact;
    public ownerDisplayName: string;
    public assignedUtcDate?: Date;
    public rootCauseVendorId: number;
    public rootCauseVendor: Vendor;
    public rootCauseVendorDisplayName: string;
    public createdBy: string;
    public attachments: RecordableAttachment[];
    public pendingAttachments: StagedBlob[];
    public changeType: ChangeType;
    public pendingUpload: boolean; 
}
